var map = {
	"./BasicTerrain.svg": 2993,
	"./Carapace.svg": 7114,
	"./Earth.svg": 992,
	"./Electric.svg": 1817,
	"./Flame.svg": 4349,
	"./Ice.svg": 1401,
	"./Water.svg": 3137,
	"./Wind.svg": 6262,
	"./Wood.svg": 51
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5722;